"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addCall = exports.execMulticall = void 0;
const ethers_1 = require("ethers");
const constants_1 = require("../../types/constants");
const abi_json_1 = __importDefault(require("./abi.json"));
const MULTICALL_NETWORKS = {
    [constants_1.ChainId.MAINNET]: '0xeefBa1e63905eF1D7ACbA5a8513c70307C1cE441',
    [constants_1.ChainId.POLYGON]: '0x11ce4B23bD875D7F5C6a31084f55fDe1e9A87507',
    [constants_1.ChainId.AVALANCHE]: '',
    [constants_1.ChainId.AURORA]: '',
    [constants_1.ChainId.FANTOM]: '',
    [constants_1.ChainId.CELO]: '',
    [constants_1.ChainId.BSC]: '',
    [constants_1.ChainId.LOCAL]: '0x0',
    [constants_1.ChainId.ARBITRUM]: '',
    [constants_1.ChainId.OPTIMISM]: '',
    [constants_1.ChainId.GNOSIS]: '',
    [constants_1.ChainId.POLYGONZKEVM]: '',
};
const MULTICALL_INTERFACE = new ethers_1.utils.Interface(abi_json_1.default);
function execMulticall(calls, provider, chainId) {
    return __awaiter(this, void 0, void 0, function* () {
        const contract = new ethers_1.Contract(MULTICALL_NETWORKS[chainId], MULTICALL_INTERFACE, provider);
        const [, returnData] = (yield contract.aggregate(calls.map((obj) => [obj.address, obj.callData])));
        return returnData.map((data, i) => {
            const success = data && data.length > 2;
            if (success) {
                try {
                    return calls[i].contractInterface.decodeFunctionResult(calls[i].fragment, data);
                }
                catch (e) {
                    console.error('Error decoding response', e);
                }
            }
        });
    });
}
exports.execMulticall = execMulticall;
const addCall = (contractInterface, address, method, callInputs) => {
    const fragment = contractInterface.getFunction(method);
    const callData = contractInterface.encodeFunctionData(fragment, callInputs);
    return {
        address,
        callData,
        fragment,
        contractInterface,
    };
};
exports.addCall = addCall;
//# sourceMappingURL=index.js.map